import type { SxProps, Theme } from "@mui/material";

// Canvas wrapper — oversized so scaled blobs are not clipped.
export const getMicVolumeHaloRootSx = (canvasPx: number): SxProps<Theme> => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  width: canvasPx,
  height: canvasPx,
  transform: "translate(-50%, -50%)",
  pointerEvents: "none",
  zIndex: 0,
  overflow: "visible",
});

export const getMicVolumeHaloCanvasSx = (): SxProps<Theme> => ({
  display: "block",
  width: "100%",
  height: "100%",
});
